import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

// Components
import BackButton from '../back-button/back-button.vue';

// Store
import { useDiscountCodeStore } from '@white-label-store/discount-code';
import { useCartCheckoutStore } from '@white-label-store/cart-checkout';
import { useUserInfoStore } from '@white-label-store/user-info';

// Helpers
import {
  goToApp,
  getDomainUrl,
  DOMAINS_NAMES,
  ECOMMERCE_URLS,
} from '@white-label-helper/switch-app';
import { getAppHeroProduct } from '@white-label-helper/get-app-hero-product';
import { getFeatureFlag } from '@white-label-plugin/launch-darkly';
import { getAppVariable } from '@white-label-helper/get-app-variable';

// Types
import {
  APP_HERO_PRODUCTS,
  PRODUCT_TYPES,
  FEATURE_FLAGS,
} from '@white-label-configuration/constants';
import { CartItem } from '@white-label-types/parking-checkout';

interface Props {
  showExtrasPageButton?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'payment-page-navigation',
  props: {
    showExtrasPageButton: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { showExtrasPageButton: boolean };



const discountCode = computed(() => useDiscountCodeStore().discountCode);
const cartItems = computed(() => useCartCheckoutStore().readCartItems);
const outboundFlightId = computed(() => useUserInfoStore().outboundFlightLookupSelected?.id);

const displayFlightLookup = computed(() => {
  const isParkingProduct = getAppHeroProduct(PRODUCT_TYPES.PARKING) === PRODUCT_TYPES.PARKING;
  const displayFlightLookupForParking = isParkingProduct && getFeatureFlag(FEATURE_FLAGS.PT_2857_FLIGHT_LOOKUP_PARKING) === true;

  return getFeatureFlag(FEATURE_FLAGS.PT_2857_FLIGHT_LOOKUP) === true
    && getAppVariable('is_flight_lookup_enabled')
    && displayFlightLookupForParking;
});

const skipCrossSellOption = computed(() => getFeatureFlag(FEATURE_FLAGS.CRO_1034_SKIP_CROSS_SELL_OPTION, false) === true);

const cartHasExtrasProduct = computed(() => {
  return cartItems.value.some(
    (item: CartItem) => item.product_code === PRODUCT_TYPES.EXTRAS
  );
});

const backToSearchButtonText = computed(() => {
  const productType = getAppHeroProduct(APP_HERO_PRODUCTS.PARKING);
  switch (productType) {
    case APP_HERO_PRODUCTS.PARKING:
      return 'chooseSpace';
    case APP_HERO_PRODUCTS.LOUNGES:
      return 'chooseLounge';
    case APP_HERO_PRODUCTS.FASTTRACK:
      return 'chooseFasttrack';
    default:
      return 'chooseSpace';
  }
});

const createNavigationQuery = (): Record<string, string> => {
  const query: Record<string, string> = {};

  if (discountCode.value) {
    query.discount = discountCode.value;
  }

  if (displayFlightLookup.value && outboundFlightId.value) {
    query.outboundFlight = outboundFlightId.value;
  }

  return query;
};

const navigateTo = (url: string, additionalParams: Record<string, string> = {}) => {
  const query = {
    ...createNavigationQuery(),
    ...additionalParams
  };

  goToApp(
    getDomainUrl(DOMAINS_NAMES.ECOMMERCE),
    url,
    query
  );
};

const goBackToSearch = () => navigateTo(ECOMMERCE_URLS.SEARCH);

/**
 * Go back to the Travel Extras page
 */
const goBackToExtras = () => navigateTo(ECOMMERCE_URLS.TRAVEL_EXTRAS);

/**
 * Go back to the Extras Product page if the cart contains an extras product,
 * or to the Search page otherwise.
 */
const goBack = () => {
  if (cartHasExtrasProduct.value) {
    navigateTo(ECOMMERCE_URLS.PRODUCT_EXTRAS);
  } else {
    goBackToSearch();
  }
};

return { __sfc: true,props, discountCode, cartItems, outboundFlightId, displayFlightLookup, skipCrossSellOption, cartHasExtrasProduct, backToSearchButtonText, createNavigationQuery, navigateTo, goBackToSearch, goBackToExtras, goBack, BackButton }
}

})